exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".guard-tour-incident-image[data-v-b153cde6]{width:50px;height:50px;margin-right:5px;border:1px solid #ccc;border-radius:10px;cursor:pointer}.guard-tour-incident-image[data-v-b153cde6]:hover{box-shadow:0 4px 8px 0 rgba(0,0,0,.2),0 6px 20px 0 rgba(0,0,0,.19);transition:.3s}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b153cde6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/guardTour/GuardIncidentReport.vue
// module id = 390
// module chunks = 0